import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { AppKeycloakBearerTokenInterceptorConfig, appKeycloakInitializer, appKeycloakProvider } from './keycloak-provider';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { emptyStringToNullInterceptor } from './empty-string-to-null.interceptor';
import { provideChunkLoadRecovery } from './util/chunk-load-recovery';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({eventCoalescing: true}),
    // KeyCloak
    appKeycloakProvider,
    appKeycloakInitializer,
    AppKeycloakBearerTokenInterceptorConfig,
    // Routing
    provideRouter(routes),
    provideChunkLoadRecovery(),
    provideHttpClient(
      withInterceptors([
        // Keycloak Token interceptor
        includeBearerTokenInterceptor,
        // Special for our API
        emptyStringToNullInterceptor,
      ]),
      // DI-based interceptors
      withInterceptorsFromDi(),
    ),
    importProvidersFrom(MatNativeDateModule),
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  ],
};
